// Sunucuda üretilip sipariş kaydında saklanan sevk formu PDF'ini açar.
export function openSevkFormu(order) {
  const base = process.env.REACT_APP_BACKEND_URL;
  const token = localStorage.getItem("token");
  const url = `${base}/api/orders/${order.id}/sevk.pdf?token=${encodeURIComponent(token || "")}`;
  window.open(url, "_blank");
}
